import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { getOVSAffiliateSelector } from 'store/onlineVisit/onlineVisit.redux';
import { ILanguageOption } from 'shared/interfaces/language.interface';
import {
  FALLBACK_LANGUAGES,
  filterSupportedLanguages,
  loadLanguageRegistry
} from 'shared/helpers/language';

export const useLanguages = (): ILanguageOption[] => {
  const affiliate = useSelector(getOVSAffiliateSelector);
  const [registry, setRegistry] = useState(FALLBACK_LANGUAGES);

  useEffect(() => {
    let active = true;
    loadLanguageRegistry().then((languages) => {
      if (active) setRegistry(languages);
    });
    return () => {
      active = false;
    };
  }, []);

  return useMemo(
    () => filterSupportedLanguages(registry, affiliate?.supportedLanguages),
    [registry, affiliate?.supportedLanguages]
  );
};
